import * as yup from 'yup';

export const activationCodeValidationSchema = yup.object().shape({
  activationCode: yup.string().required( 'El código de activación es requerida' ),
});
